/*
 * Atha Clinic — referência da conta da app (asset `atha-ref.js` do tema Dwell).
 *
 * A app do doente abre a loja com `?atha_ref=<referência cifrada>`. Este script
 * guarda-a como atributo do carrinho; o Shopify copia-a para a encomenda
 * (`note_attributes`) e o webhook da Atha liga a compra à ficha. A referência é
 * opaca: só a Atha a lê. Sai do endereço logo a seguir, para não ficar no
 * histórico nem em links partilhados.
 */
(function () {
  var PATTERN = /^[A-Za-z0-9_-]{40,512}$/;
  var url;
  try {
    url = new URL(window.location.href);
  } catch (error) {
    return;
  }
  var ref = url.searchParams.get('atha_ref');
  if (ref === null) return;

  url.searchParams.delete('atha_ref');
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  if (!PATTERN.test(ref)) return;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ attributes: { atha_ref: ref } }),
  }).catch(function () {});
})();
